import type { RawMSResponse } from '@/domains/productDiscovery/microservices/interfaces/RawMSResponse';

import type { Recommendations } from './productRecommendation';

export interface ParentCategory {
  id: number;
}

export interface ParentsCategory {
  id: number;
  position: number;
}

export interface PlatformId {
  name: string;
  slug: string;
  display: boolean;
}

export interface CategoryItem {
  id: number;
  name: string;
  level: number;
  image: string;
  parent: ParentCategory;
  platform: {
    [key: string]: PlatformId;
  };
  slug: string;
  parents: Array<ParentsCategory>;
}

export interface PlaylistDetails {
  title?: string;
  engineName?: string;
  displayType?: string;
  displayAddToCartButton?: boolean;
}

export interface CategoriesRecoPlaylist {
  id?: number;
  items: Omit<CategoryItem, 'parent' | 'parents' | 'platform'>[];
  title?: string;
  engineName?: string;
  originalName?: string;
  displayType?: string;
  displayAddToCartButton?: boolean;
}

export interface CategoriesRecommendationsState {
  fetching: boolean;
  recommendations?: CategoriesRecoPlaylist[];
  topSalesCategoriesRecommendations?: Recommendations[];
  error?: string;
}

export const initialState: CategoriesRecommendationsState = {
  fetching: false,
};

export type MsCatalogCategoryResponse = RawMSResponse<Array<CategoryItem>>;

export enum MS_CATALOG_URL {
  V3 = '/v3/categories',
}
